import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock, User, Building, AlertCircle, CheckCircle2 } from 'lucide-react';
export function Register() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    password: '',
    userType: 'Customer'
  });
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!formData.firstName || !formData.email || !formData.password) {
      setError('Please fill in all required fields.');
      return;
    }
    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans animate-in fade-in duration-500" data-id="element-709" data-mp="3b7owaq1tn71a">
        <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-710" data-mp="3g68j0so8omup">
          <div className="bg-white py-10 px-6 shadow-sm border border-slate-200 sm:rounded-xl text-center" data-id="element-711" data-mp="7px0f0kke2xt">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 mb-4" data-id="element-712" data-mp="co8a9bav0dg1">
              <CheckCircle2 className="h-6 w-6 text-emerald-600" data-id="element-713" data-mp="3u586hx00mvpa" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-714" data-mp="2yeyoaapvybs">
              Check your email
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-715" data-mp="qnhpo8r8r3iy">
              We've sent a verification link to{' '}
              <strong data-id="element-716" data-mp="vhc6n4fgp4ec">{formData.email}</strong>. Please verify your email to
              continue.
            </p>
            <Link to="/login" className="w-full flex justify-center py-2.5 px-4 border border-slate-300 rounded-md shadow-sm text-sm font-medium text-slate-700 bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 transition-colors" data-id="element-717" data-mp="159ncb8ap9ii6">
              Return to login
            </Link>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans animate-in fade-in duration-500" data-id="element-718" data-mp="hmf7ssl3idh7">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-719" data-mp="cnvmmuebt5pw">
        <div className="flex justify-center" data-id="element-720" data-mp="8lqvq3f9in6y">
          <div className="w-10 h-10 bg-slate-900 rounded-md" data-id="element-721" data-mp="8n1xjxp5dkvf"></div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900" data-id="element-722" data-mp="3lcm4gy0j56t">
          Create your account
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-723" data-mp="3utgwk050t49u">
          Already have an account?{' '}
          <Link to="/login" className="font-medium text-slate-900 hover:underline" data-id="element-724" data-mp="2acqyz7nv3mtv">
            Sign in
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-725" data-mp="2k9c4rv7ph1yr">
        <div className="bg-white py-8 px-4 shadow-sm border border-slate-200 sm:rounded-xl sm:px-10" data-id="element-726" data-mp="2oaxn3w30e8gc">
          <form className="space-y-5" onSubmit={handleSubmit} data-id="element-727" data-mp="1rky75gkj47nq">
            {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm flex items-start" data-id="element-728" data-mp="1wiqbja2d1m8t">
                <AlertCircle className="h-5 w-5 mr-2 shrink-0 mt-0.5" data-id="element-729" data-mp="20js8tlcpvo85" />
                <span data-id="element-730" data-mp="25c3bux2r7q4x">{error}</span>
              </div>}

            <div className="grid grid-cols-2 gap-4" data-id="element-731" data-mp="25def8vsaevvi">
              <div data-id="element-732" data-mp="18sm9h74tlujx">
                <label htmlFor="firstName" className="block text-sm font-medium text-slate-700" data-id="element-733" data-mp="18t5n4bnftws5">
                  First name *
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-734" data-mp="tqx6rzv8zl8j">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-735" data-mp="oslxbq8v7cqu">
                    <User className="h-4 w-4 text-slate-400" data-id="element-736" data-mp="13h8pisjlbyzh" />
                  </div>
                  <input id="firstName" name="firstName" type="text" required value={formData.firstName} onChange={handleChange} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-737" data-mp="yopb5td2wztm" />
                </div>
              </div>
              <div data-id="element-738" data-mp="3o5wevw2j6vqx">
                <label htmlFor="lastName" className="block text-sm font-medium text-slate-700" data-id="element-739" data-mp="3o7halp0l0kqd">
                  Last name
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-740" data-mp="1yqvf9f1bk83a">
                  <input id="lastName" name="lastName" type="text" value={formData.lastName} onChange={handleChange} className="block w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-741" data-mp="23p5fi41whyvr" />
                </div>
              </div>
            </div>

            <div data-id="element-742" data-mp="160v8tbr66myb">
              <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-743" data-mp="161erwvsk3hdx">
                Work email *
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-744" data-mp="30f5x9j3urf3k">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-745" data-mp="30ctifete5kuq">
                  <Mail className="h-4 w-4 text-slate-400" data-id="element-746" data-mp="35bwn2y5glp26" />
                </div>
                <input id="email" name="email" type="email" required value={formData.email} onChange={handleChange} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-747" data-mp="33yer1odiwwjz" />
              </div>
            </div>

            <div data-id="element-748" data-mp="3hnp314e8jimj">
              <label htmlFor="company" className="block text-sm font-medium text-slate-700" data-id="element-749" data-mp="3hp9xyv4gp3kx">
                Company name
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-750" data-mp="37xdvz8z98tbf">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-751" data-mp="985a66hh8280">
                  <Building className="h-4 w-4 text-slate-400" data-id="element-752" data-mp="4hymq9ypanrc" />
                </div>
                <input id="company" name="company" type="text" value={formData.company} onChange={handleChange} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-753" data-mp="cqcj5fkbxiti" />
              </div>
            </div>

            <div data-id="element-754" data-mp="vo5mgiyv7urf">
              <label htmlFor="userType" className="block text-sm font-medium text-slate-700" data-id="element-755" data-mp="vop5k3094p71">
                Account Type
              </label>
              <select id="userType" name="userType" value={formData.userType} onChange={handleChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-slate-300 focus:outline-none focus:ring-slate-900 focus:border-slate-900 sm:text-sm rounded-md bg-white" data-id="element-756" data-mp="14itp01d22ycj">
                <option value="Customer" data-id="element-757" data-mp="24p85sdnc44tx">Standard User (Customer)</option>
                <option value="Administrator" data-id="element-758" data-mp="1zqn8on3dq19p">
                  Organization Administrator
                </option>
              </select>
            </div>

            <div data-id="element-759" data-mp="2dpwauiur2uuo">
              <label htmlFor="password" className="block text-sm font-medium text-slate-700" data-id="element-760" data-mp="2dobsdrlpn2d6">
                Password *
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-761" data-mp="1l20i1p8axn36">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-762" data-mp="1h16tquqy669r">
                  <Lock className="h-4 w-4 text-slate-400" data-id="element-763" data-mp="1uslmvuekjnuj" />
                </div>
                <input id="password" name="password" type="password" required value={formData.password} onChange={handleChange} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" placeholder="At least 8 characters" data-id="element-764" data-mp="1q0bum7pzebp3" />
              </div>
            </div>

            <div data-id="element-765" data-mp="3004o59t5ctwz">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 disabled:opacity-70 transition-colors" data-id="element-766" data-mp="300o8sya6lwep">
                {isLoading ? 'Creating account...' : 'Create account'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}